import { render, staticRenderFns } from "./AppLoadingContainer.vue?vue&type=template&id=3461e50e&"
import script from "./AppLoadingContainer.vue?vue&type=script&lang=js&"
export * from "./AppLoadingContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports